<template>
  <van-dialog
    class="reward-box--dailog"
    v-model="show"
    :show-confirm-button="false"
    :before-close="handleClose"
    close-on-click-overlay
    @confirm="payFunc"
    >
    <div class="msg">
      该付费内容需要支付
      <font class="text-red">￥{{amount.toFixed(2)}}</font>
    </div>
    <chosePayMethodBlock v-model="payType" />
    <div class="btn-box">
      <van-button type="primary" size="large" class="pay-btn" @click="payFunc">立即支付</van-button>
    </div>
  </van-dialog>
</template>
<script>
import { Cms } from "@/api";
import chosePayMethodBlock from '@/components/pay/chosePayMethodBlock.vue'
import payServices from '@/services/payServices'
export default {
  name: "paidReadDialog",
  components: {chosePayMethodBlock},
  data() {
    return {
      articleId: 0,
      title: "",
      show: false,
      amount: 10,
      userInfo: {},
      payType: 'wx'
    };
  },
  methods: {
    init(data, articleId, title, Price) {
      this.articleId = articleId;
      this.userInfo = data;
      this.title = title;
      this.amount = Price
      this.show = true;
    },
    handleClose() {
      this.show = false;
    },
    async payFunc() {
      if (this.amount <= 0) {
        this.$tips.toast("数据错误，请刷新页面");
        return;
      }

      let SubscribeArticleResp = await this.$api(Cms.SubscribeArticle, {
        articleId: this.articleId,
      });

      payServices.pay({
        paymentId: SubscribeArticleResp.Id,
        payAmount: SubscribeArticleResp.Amount,
        payMsg:  `付费-${this.title}`,
        payType:  this.payType,
        payFor: 3,
      }).then(() => {
        this.$mdUtils.isWeiXin() && this.$emit('paySuccess')
        this.handleClose()
      })
    },
   
  }
};
</script>
<style lang='scss' scoped>
.msg {
  padding: 20px 0;
  text-align: center;
}

</style>